/**
 * Withdrawal Handler
 * 
 * Manages withdrawal iframe initialization and updates.
 * Follows Single Responsibility Principle - only manages withdrawal integration.
 * 
 * @package betbeast
 */

import { initializePaymentIQForm } from '../payment-iq-cashier.js';

export class WithdrawalHandler {
    constructor(modalElement) {
        this.modal = modalElement;
        this.partyId = null;
        this.sessionKey = null;
        
        if (!this.modal) {
            console.warn('Modal element not provided to WithdrawalHandler');
            return;
        }
        
        this.init();
    }
    
    /**
     * Initialize withdrawal handler with data attributes
     */
    init() {
        const container = this.modal.querySelector('.wallet-withdrawal-form-wrapper');
        if (!container) {
            console.warn('Withdrawal form wrapper not found in modal');
            return;
        }
        
        // Get party ID and session key from data attributes if needed
        // For now, these might come from a different source
        // this.partyId = container.dataset.partyId;
        // this.sessionKey = container.dataset.sessionKey;
    }
    
    /**
     * Initialize or update withdrawal form
     */
    updateWithdrawalForm() {
        // Withdrawal-specific form updates would go here
        // For example, loading available withdrawal methods
        console.log('Withdrawal form ready');
    }
    
    /**
     * Process withdrawal
     * @param {string} paymentMethod - Payment method code (e.g., APCOPAY_V2_CARD)
     * @param {number} amount - Withdrawal amount
     * @param {string} paymentInformationId - Payment information ID (required for APCOPAY_V2_CARD)
     * @param {string} conversionId - Conversion ID (if conversion is required)
     * @param {Object} extraFields - Extra schema-defined fields keyed by field code
     * @param {string} variantKey - Variant id (CPT post id) for per-variant schema selection
     * @returns {Promise}
     */
    processWithdrawal(paymentMethod, amount, paymentInformationId = null, conversionId = null, extraFields = {}, variantKey = '') {
        console.log('=== Processing Withdrawal ===');
        console.log('Payment Method:', paymentMethod);
        console.log('Amount:', amount);
        console.log('Payment Information ID:', paymentInformationId);
        console.log('Conversion ID:', conversionId);
        if (Object.keys(extraFields).length) {
            console.log('Extra Fields:', extraFields);
        }
        
        return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append('action', 'betbeast_process_withdrawal');
            formData.append('nonce', window.accountData?.nonce || '');
            formData.append('payment_method', paymentMethod);
            if (variantKey) {
                formData.append('variant_key', variantKey);
            }
            formData.append('amount', amount);

            if (paymentInformationId) {
                formData.append('payment_information_id', paymentInformationId);
            }
            
            if (conversionId) {
                formData.append('conversion_id', conversionId);
            }

            // Append schema-defined extra fields as extra_fields[code]=value
            for (const [code, value] of Object.entries(extraFields)) {
                if (value !== '' && value !== null && value !== undefined) {
                    formData.append(`extra_fields[${code}]`, value);
                }
            }
            
            fetch(window.accountData?.ajaxUrl || '/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                console.log('=== Withdrawal Response ===');
                console.log(data);
                
                if (data.success) {
                    resolve(data.data);
                } else {
                    reject(new Error(data.data?.message || 'Withdrawal failed'));
                }
            })
            .catch(error => {
                console.error('Withdrawal Error:', error);
                reject(error);
            });
        });
    }
}
